import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import SmallPieGraph from "../../../general/SmallPieGraph";
import PieGraph from "../../../general/PieGraph";
import BarGraph from "../../../general/BarGraph";
import styles from "./AmbientalL3.module.css";

function AmbientalL3({ distrito }) {
  const [agrotoxico, setAgrotoxico] = useState(null);
  const [problemaSaudeAgrotoxico, setProblemaSaudeAgrotoxico] = useState(null);
  const [tipoMata, setTipoMata] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [agrotoxico, problemaSaudeAgrotoxico, tipoMata] =
          await Promise.all([
            Api.getAgrotoxico(distrito),
            Api.getProblemasSaudeAgrotoxico(distrito),
            Api.getTipoMata(distrito),
          ]);
        setAgrotoxico(Functions.buildSmallPieGraphParams(agrotoxico));
        setProblemaSaudeAgrotoxico(Functions.buildPieGraphParams2(problemaSaudeAgrotoxico));
        setTipoMata(Functions.buildBarGraph(tipoMata));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [distrito]);
  const mockupFunction = (value) => {
    value = value + 1;
  };

  return (
    <div className={styles.ambientalL3}>
      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {agrotoxico && (
            <SmallPieGraph
              data={agrotoxico}
              text="USO DE AGROTÓXICO"
              onLegendClick={mockupFunction}
              currentValue={null}
              oldValue={null}
              onOldValue={mockupFunction}
              onImageReady={mockupFunction}
            />
          )}
        </div>
      </div>

      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {problemaSaudeAgrotoxico && (
            <PieGraph
              data={problemaSaudeAgrotoxico}
              text="PROBLEMA DE SAÚDE POR USO DE AGROTÓXICO"
              onLegendClick={mockupFunction}
              currentValue={null}
              oldValue={null}
              onOldValue={mockupFunction}
              onImageReady={mockupFunction}
            />
          )}
        </div>
      </div>

      <div className={styles.pieGraph}>
        <div className={styles.graph}>
          {tipoMata && (
            <BarGraph
              data={tipoMata}
              text="TIPO DE MATA"
              onImageReady={mockupFunction}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default AmbientalL3;
